<template>
  <div class="min-h-screen">
    <header class="px-4 md:px-6 pt-4 sm:pt-6 font-headings bg-black text-white">
      <h2 class="absolute md:mt-2">
        <logo />
      </h2>
      <h1 class="w-full text-center text-xl md:text-4xl mb-4 font-medium mt-6 md:mt-0">{{ title }}</h1>
      <nav class="mt-5 pb-5">
        <ul class="flex flex-wrap justify-center uppercase font-medium text-sm">
          <li class="pr-2 md:pr-4">
            <router-link class="no-underline" :to="`/${regionToSlug('amazonas')}/${localizedDimension}`">
              {{ regionToName('amazonas') }}
            </router-link>
          </li>
          <li class="px-2 md:px-4">
            <router-link class=" whitespace-no-wrap" :to="`/${regionToSlug('africa')}/${localizedDimension}`">
              {{ regionToName('africa') }}
            </router-link>
          </li>
          <li class="pl-2 md:pl-4">
            <router-link class=" whitespace-no-wrap" :to="`/${regionToSlug('asia')}/${localizedDimension}`">
              {{ regionToName('asia') }}
            </router-link>
          </li>
        </ul>
        <div class="text-center mt-3 flex justify-center items-center" v-if="country">
          <span class="arrow arrow--right text-brand-bright" />
          <span class="arrow arrow--right text-brand-bright" />
          {{ iso3ToName(country) }}
        </div>
      </nav>
      <nav class="absolute top-0 right-0 mr-4 md:mr-6 mt-2 sm:mt-4 md:mt-6 text-sm">
        <ul class="flex">
          <li class="mr-2"><router-link :to="url('no')">NO</router-link></li>
          <li><router-link :to="url('en')">EN</router-link></li>
        </ul>
      </nav>
    </header>
    <router-view class="p-4 md:p-8 font-body" />
    <footer class="text-white bg-brand-dark-cyan px-4 md:px-8 py-8 text-sm sm:text-base">
      <logo class="mb-8" />
      <div v-html="footerTitle" class="mb-8 text-base sm:text-lg"></div>
      <div class="mb-8">
        <h2 class="text-lg">
          <svg class="icon icon-info text-brand-bright"><use xlink:href="#icon-info"></use></svg>
          {{ dataSources }}
        </h2>
        <ul class="leading-relaxed">
          <li v-html="forestCitations"></li>
          <li v-html="deforestationCitations"></li>
          <li v-html="fireCitations"></li>
        </ul>
      </div>
      <div class="flex flex-wrap md:flex-no-wrap md:space-x-8">
        <p class="w-full sm:w-1/2 xl:w-1/4 mb-8">
          <span v-html="websiteLink"></span><br />
          Mariboes gate 8, 0183 Oslo<br />
        </p>
        <p class="w-full sm:w-1/2 xl:w-1/4 mb-8">
          <a href="mailto:regnskog@regnskog.no" class="link">regnskog@regnskog.no</a><br />
          (+47) 23 10 95 00<br />
        </p>
        <p class="w-full sm:w-1/2 xl:w-1/4 mb-8">
          Org. nr. 985 828 806<br />
          Vipps: 33333<br />
        </p>
        <p class="w-full sm:w-1/2 xl:w-1/4 mb-8">
          {{ memberOfText }}
        </p>
      </div>
      <div class="flex flex-wrap md:flex-no-wrap md:space-x-8">
        <p class="w-full text-center text-xs">
          {{ madewithpride }} <a target="_blank" href="https://kartoteket.as" class="link">Kartoteket</a>
        </p>
      </div>
    </footer>

    <symbol id="icon-info" viewBox="0 0 24 24">
      <path
        d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
      />
    </symbol>
  </div>
</template>
<script>
import Logo from '@/components/Logo'
import { regionToSlug as _regionToSlug, regionToName as _regionToName, dimensionToSlug } from '@/utils/helpers'
import { iso3ToName, iso3ToSlug } from '@/utils/countryMap'

export default {
  components: {
    Logo
  },
  computed: {
    localizedDimension() {
      return this.$store.state.dimensionSlug
    },
    dimension() {
      return this.$store.state.dimension
    },
    language() {
      return this.$store.state.language
    },
    region() {
      return this.$store.state.region
    },
    country() {
      return this.$store.state.country
    },
    title() {
      return this.$store.getters.localizedString('title')
    },
    footerTitle() {
      return this.$store.getters.localizedString('footerTitle')
    },
    dataSources() {
      return this.$store.getters.localizedString('dataSources')
    },
    forestCitations() {
      return this.$store.getters.localizedString('forestCitations')
    },
    deforestationCitations() {
      return this.$store.getters.localizedString('deforestationCitations')
    },
    fireCitations() {
      return this.$store.getters.localizedString('fireCitations')
    },
    websiteLink() {
      return this.$store.getters.localizedString('websiteLink')
    },
    memberOfText() {
      return this.$store.getters.localizedString('memberOfText')
    },
    madewithpride() {
      return this.$store.getters.localizedString('madewithpride')
    }
  },
  methods: {
    iso3ToName: iso3ToName,
    regionToSlug(slug) {
      return _regionToSlug(slug, this.language)
    },
    regionToName(region) {
      return _regionToName(region, this.language)
    },
    url(language) {
      const country = this.country ? `/${iso3ToSlug(this.country, language)}` : ''
      return `/${_regionToSlug(this.region, language)}/${dimensionToSlug(this.dimension, language)}${country}`
    }
  }
}
</script>
<style>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  /* stroke-width: 0; */
  stroke: currentColor;
  fill: currentColor;
}

.router-link-active {
  border-bottom: 2px solid theme('colors.brand.bright');
}
.link {
  border-bottom: 1px solid theme('colors.brand.bright');
  padding-bottom: 1px;
}
</style>
